import { useLayoutEffect, useState } from "react";

const useContainerSize = ({
  width: measureWidth = true,
  height: measureHeight = true,
} = {}) => {
  const [element, setElement] = useState(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!element) {
      return;
    }

    let rafId = null;
    const resizeObserver = new ResizeObserver((entries) => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const { width: w, height: h } = entries[entries.length - 1].contentRect;
        if (measureWidth) {
          setWidth(w);
        }
        if (measureHeight) {
          setHeight(h);
        }
      });
    });

    resizeObserver.observe(element);

    const rect = element.getBoundingClientRect();
    if (measureWidth) {
      setWidth(rect.width);
    }

    if (measureHeight) {
      setHeight(rect.height);
    }

    return () => {
      cancelAnimationFrame(rafId);
      resizeObserver.disconnect();
    };
  }, [element]);

  return { ref: setElement, width, height };
};

export default useContainerSize;
